import { createIcon } from '@chakra-ui/react'

export const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 18 18',
  path: (
    <g fill="none" fillRule="evenodd">
      <line
        x1="9"
        y1="1"
        x2="9"
        y2="17"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="1"
        y1="9"
        x2="17"
        y2="9"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  ),
})
